<template>
  <div class="app-container" id="my-node">
    <el-image class="logo" src="../../static/images/xjht_logo.png" />
    <div class="userBar">
      <div class="row-public">
        <div class="text">选择楼盘</div>
        <el-select popper-class="realTable-select" class="select-flex1" multiple ref="agent1Select"
          @hook:mounted="cancalReadOnly" @visible-change="cancalReadOnly" filterable placeholder="请选择楼盘"
          default-first-option :remote-method="searchEstate" remote v-model="real_estate_id" @change="addTempList">
          <el-option v-for="(item, index) in realList" :key="index" :label="item.real_estate_name" :value="item.id">
          </el-option>
          <el-option v-show="false" v-for="item in tempList" :key="item.id" :label="item.real_estate_name"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="row-public">
        <div class="text">指定日期</div>
        <el-date-picker v-model="start_date" type="date" placeholder="请选择日期" value-format="yyyy-MM-dd" class="date-item"
          :picker-options="pickerOptions">
        </el-date-picker>
        <div class="space">至</div>
        <el-date-picker v-model="end_date" type="date" placeholder="请选择日期" value-format="yyyy-MM-dd" class="date-item"
          :picker-options="pickerOptions">
        </el-date-picker>
        <div class="right flexBox">
          <div class="text">统计方式</div>
          <el-radio v-model="analyseWay" label="单日">单日</el-radio>
          <el-radio v-model="analyseWay" label="总计">总计</el-radio>
        </div>
      </div>

      <div class="row-public">
        <div class="text">位置数据</div>
        <el-select ref="agent2Select" popper-class="realTable-select" class="select-flex1"
          @hook:mounted="cancalReadOnly" @visible-change="cancalReadOnly" v-model="needCols" multiple filterable
          default-first-option placeholder="选择位置">
          <el-option v-for="(value, key) in colMap" :key="key" :label="key" :value="key">
          </el-option>
        </el-select>
      </div>
      <div>
        <el-button type="primary" @click="getHitsData" class="select-btn" icon="el-icon-search">查询</el-button>
        <el-button type="primary" @click="shotPic" class="download-btn" icon="el-icon-download">下载</el-button>
      </div>
    </div>
    <div class="table-box" v-if="salesData.length > 0 || (everyDayHits.length > 0 && needCols1.length > 0 && analyseWay !== '顾问')">
      <!-- 合计或总计的数据 -->
      <div v-for="(i, index) in real_estate_id" :key="i.id" class="estate-box">
        <div v-if="everyDayHits.length > 0 && needCols1.length > 0 && analyseWay !== '顾问' && real_estate_name[index]"
          class="estate-table">
          <!-- 楼盘名 -->
          <div class="title">{{ real_estate_name[index] }}</div> 

          <el-table :data="everyDayHits[index]" border @header-click="onHeadClick"
            @cell-click="(row, col) => onCellClick(row, col, index)">
            <el-table-column prop="date" label="日期" min-width="120">
            </el-table-column>
            <el-table-column v-for="col in needCols1" :key="col" :prop="colMap[col]" :label="col"
              :min-width="['总分配线索', '手动分配线索', '群聊活跃人数', '买房问答贴片', '排行榜贴片', '学区找房贴片', '预计开盘贴片', '正在登记贴片', '正在公示贴片'].includes(col) ? 110 : 86">
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!-- 按照销售分类的数据 -->
      <div v-for="(i, index) in real_estate_id" :key="i.id" class="estate-box">
        <div v-if="salesData[index] && salesData[index].length > 0 && user[index].length > 0 && real_estate_name[index]"
          class="estate-table">
          <div class="title">{{ salesDataName[index] }}</div>
          <el-table :data="salesData[index]" border @header-click="onSaleHeadClick"
            @cell-click="(row, col) => onSaleCellClick(row, col, index)">
            <el-table-column prop="user_name" label="顾问" min-width="120">
            </el-table-column>
            <el-table-column v-for="(item, key ) in user[index]" :key="key" :prop="gwCols[item]" :label="item"
              :min-width="['咨询平均回复时间'].includes(item) ? 140 : ['5分钟回复率', '1分钟回复率', '咨询回复率'].includes(item) ? 100 : 90">
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import domtoimage from 'dom-to-image'

export default {
  data() {
    return {
      realList: [],
      everyDayHits: [], //单计 总计
      real_estate_id: [],
      real_estate_name: [],
      start_date: '',
      end_date: '',
      needCols: ['关注量', '1v1', '咨询量','咨询条数','电话量', '群聊联系','复制微信','复制联系方式','访问量','产生回拨数','交换联系方式数'], //位置数据展示的字段
      needCols1: [],  //单计总计表要展示的字段
      // 按日期排的键值对，总计，单计
      colMap: {
        '开屏': 'open',
        '首页贴片': 'top',
        '热门位置': 'hot',
        '关注量': 'follow',
        '1v1': '1v1',
        '咨询量': 'chet',
        '咨询条数': 'chatNum',
        '电话量': 'phonecall',
        '群聊联系': 'group',
        '复制微信':'cpoyWxNum',
        '访问量': 'total',
        '搜索框': 'search',
        '正在公示贴片': 'gongshi',
        '正在登记贴片': 'dengji',
        '预计开盘贴片': 'yuji',
        '学区找房贴片': 'school',
        '找房贴片': 'zhaofang',
        '排行榜贴片': 'paihang',
        '买房问答贴片': 'wenda',
        '咨询回复率': 'replyRate',
        '咨询平均回复时间': 'replyTime',
        '红包获客': 'redpacket',
        '群聊活跃人数': 'activeChat',
        '手动分配线索': 'giveHand',
        '总分配线索': 'giveTotal',
        '消息条数': 'talksTotal',
        '交换微信': 'wx_num',
        '成交数量': 'turnoverNum',
        '预约看房': 'reservation',
        '1分钟回复率': 'oneMinReply',
        '5分钟回复率': 'fiveMinReply',
        '产生回拨数':'callback',
        '复制联系方式':'advisorContact',
        '交换联系方式数':'contactExchange'
      },
      // 顾问详情的键值对
      gwCols: {
        '咨询量': 'num1',
        '咨询条数': 'talk_num',
        '电话量': 'num2',
        '群聊联系': 'num3',
        '红包获客': 'num4',
        '1v1': 'num5',
        '咨询回复率': 'chatBackRate',
        '咨询平均回复时间': 'chatBackTime',
        '交换微信': 'wx_num',
        '复制微信': 'wx_copy_num',
        '成交数量': 'turnoverNum',
        '预约看房': 'reservation',
        '1分钟回复率': 'oneMinReply',
        '5分钟回复率': 'fiveMinReply',
        '产生回拨数':'callback',
        '复制联系方式':'advisorContact',
        '交换联系方式数':'contactExchange'
      },

      analyseWay: '单日',
      user: [], //顾问详情要展示的数据 二维数组
      salesData: [], //按照销售分类的统计数据
      salesDataName: [],
      tempList: [],

      pickerOptions: {
        cellClassName(Date) {
          return 'custom-date';
        }
      },
    }
  },
  watch: {
    analyseWay(val, old) {
      if (val === '顾问') {
        this.needCols = []
      }
      if (val !== '顾问' && old === '顾问') {
        this.needCols = []
      }
    },
    needCols(val) {
      this.modifyCols(val)
    },
  },
  beforeRouteEnter(to, from, next) {
    if (from.name === 'login') {
      to.meta.isBack = true;
    }
    next();
  },
  activated() {
    if (!this.$route.meta.isBack) {
      let origin = this.$options.data();
      Object.assign(this.$data, origin)
    }
    this.$route.meta.isBack = false
  },
  methods: {
    getFormatDate(day){
      day = day || 0;
      let formateDay = this.$moment(new Date()).subtract(day,'days').format('YYYY-MM-DD');
      return formateDay
    },
    modifyCols(data1) {  //选中的col
      let totalNeed = {
        '预约看房': 'reservation',
        '1分钟回复率': 'oneMinReply',
        '5分钟回复率': 'fiveMinReply',
        '交换微信': 'wx_num',
        '咨询平均回复时间': 'replyTime',
        '咨询回复率': 'replyRate',
      }
      // 排除掉totalNeed包含的数据
      this.needCols1 = data1.filter(x => {
        return !totalNeed[x];
      })
      this.user = this.salesData.map(() => data1.filter(col => this.gwCols[col]))
    },
    addTempList(e) {
      this.tempList = this.realList.filter(x => {
        for (const id of e) {
          if (id === x.id) return true
        }
        return false
      })
    },
    async getHitsData() {
      let that = this;
      let start_date = that.start_date;
      let end_date = that.end_date;
      if (!that.real_estate_id.length) {
        that.$message.error('请选择楼盘');
        return;
      }
      if (!start_date || !end_date) {
        that.$message.error('请选择日期');
        return;
      }
      let start = new Date(start_date).getTime();
      let end = new Date(end_date).getTime();
      if (start > end) {
        that.$message.error('日期不对');
        return;
      }
      that.needCols1 = [];
      if (that.analyseWay == '总计' || that.analyseWay == '单日') {
        that.modifyCols(that.needCols)
        if (that.needCols1.length == 0) {
          that.$message.error('选择要哪些位置的数据');
          return;
        }
      }
      if (that.needCols.length == 0 && that.analyseWay == '顾问') {
        that.$message.error('选择要哪些位置的数据');
        return;
      }
      that.$open();
      if (that.analyseWay == '单日') {
        await that.getSingleData(start_date, end_date);
        await that.getSaleChatDetail(start_date, end_date, that.needCols, new Date().getTime());
      } else if (that.analyseWay == '总计') {
        await that.getTotalData(start_date, end_date, that.needCols1, new Date().getTime());
        await that.getSaleChatDetail(start_date, end_date, that.needCols, new Date().getTime());
      } else {
        await that.getSaleChatDetail(start_date, end_date, that.needCols, new Date().getTime());
      }
      that.$close();
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async getSingleData(start_date, end_date) {
      let that = this;
      that.real_estate_name = [];
      that.everyDayHits = [];
      try {
        let timestamp = new Date();
        for (let index = 0; index < that.real_estate_id.length; index++) {

          let res = await that.$axios.get(that.$url_prefix + 'behaviourAnalyse', {
            params: {
              type: '点击楼盘',
              target: that.real_estate_id[index],
              top: end_date,
              bottom: start_date,
              timestamp,
            }
          })
          console.log('behaviourAnalyse',res.data && res.data.data)
          if (!res.data.success) {
            that.$message.error('查询失败');
            return;
          }

          if (!res.data.data) {
            await that.sleep(2000);
            index--;
            continue;
          }
          that.real_estate_name.push(res.data.name);
          that.everyDayHits.push(res.data.data);
        }
      } catch (err) {
        console.log('err', err);
        that.$message.error('查询失败');
      }
    },
    async getTotalData(start_date, end_date, needCols, timestamp) {
      let that = this;
      try {
        that.everyDayHits = [];
        that.real_estate_name = [];
        for (let index = 0; index < that.real_estate_id.length; index++) {
          let res = await that.$axios.post(that.$url_prefix + 'getTotalHits', {
            target: that.real_estate_id[index],
            top: end_date,
            bottom: start_date,
            needCols: needCols,
            timestamp: timestamp
          })
          if (!res.data.data) {
            await that.sleep(2000);
            index--;
            continue;
          }
          console.log('getTotalHits', res.data);
          await that.real_estate_name.push(res.data.real_estate_name);
          await that.everyDayHits.push(res.data.data);
        }
      } catch (err) {
        console.log('err', err);
        that.$message.error('查询失败');
      }
    },
    async getSaleChatDetail(start_date, end_date, needCols, timestamp) {
      let that = this;
      try {
        that.user = [];
        that.salesData = [];
        that.salesDataName = [];
        let allCol = Object.keys(that.colMap)
        for (let index = 0; index < that.real_estate_id.length; index++) {
          let res = await that.$axios.post(that.$url_prefix + 'getSaleChatDetail', {
            target: that.real_estate_id[index],
            top: end_date,
            bottom: start_date,
            needCols: allCol,
            timestamp: timestamp
          })
          console.log('getSaleChatDetail', res.data && res.data.data);
          if (res.data.data) {
            that.salesData.push(res.data.data);
            that.salesDataName.push(res.data.real_estate_name);
            that.modifyCols(needCols);
          }
        }
      } catch (err) {
        console.log('err', err);
        that.$message.error('查询失败');
      }
    },
    onHeadClick(col) {
      let that = this;
      let prop = col.property;
      let pos = '所有位置翻多少倍';
      if (prop != 'date') {
        for (let key in that.colMap) {
          if (that.colMap[key] == prop) {
            pos = key + '翻多少倍';
            break;
          }
        }
      }
      that.$prompt(pos, '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: ''
      }).then(({
        value
      }) => {
        let multi = parseFloat(value);
        if (multi) {
          let arr = that.everyDayHits;
          for (let k = 0; k < arr.length; k++) {
            let list = arr[k];
            for (let i = 0; i < list.length; i++) {
              let one = list[i];
              if (prop == 'date') {
                for (let key in one) {
                  if (key != 'date') {
                    one[key] = Math.round(one[key] * multi);
                  }
                }
              } else {
                one[prop] = Math.round(one[prop] * multi);
              }
            }
          }
        } else {
          that.$message.error('请填写正确的倍数');
        }
      }).catch((err) => {
        console.log('取消翻倍', err);
      })
    },
    onSaleHeadClick(col) {
      let that = this;
      let prop = col.property;
      let pos = '所有位置翻多少倍';
      if (prop != 'date') {
        for (let key in that.colMap) {
          if (that.colMap[key] == prop) {
            pos = key + '翻多少倍';
            break;
          }
        }
      }
      that.$prompt(pos, '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: ''
      }).then(({
        value
      }) => {
        let multi = parseFloat(value);
        if (multi) {
          let arr = that.salesData;
          for (let k = 0; k < arr.length; k++) {
            let list = arr[k];
            for (let i = 0; i < list.length; i++) {
              let one = list[i];
              if (prop == 'date') {
                for (let key in one) {
                  if (key != 'date') {
                    one[key] = Math.round(one[key] * multi);
                  }
                }
              } else {
                one[prop] = Math.round(one[prop] * multi);
              }
            }
          }
        } else {
          that.$message.error('请填写正确的倍数');
        }
      }).catch((err) => {
        console.log('取消翻倍', err);
      })
    },
    searchEstate(search) {
      let that = this;
      if (search) {
        that.$axios
          .get(that.$url_prefix + "searchEstateName", {
            params: {
              type: '全部',
              search: search
            }
          })
          .then(res => {
            that.realList = res.data.data;
            console.log('that.realList', that.realList);
          });
      }
    },
    onCellClick(row, col, tn) {
      let that = this;
      let list = that.everyDayHits[tn];
      let index = list.findIndex(x => {
        return x.date == row.date;
      })
      let one = list[index];
      if (one) {
        that.$prompt('改多少', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputValue: ''
        }).then(({
          value
        }) => {
          let multi = parseInt(value);
          if (multi) {
            one[col.property] = multi;
          } else {
            that.$message.error('请填写正确的数字');
          }
        }).catch((err) => {
          console.log('取消修改', err);
        })
      }
    },
    onSaleCellClick(row, col, tn) {
      let that = this;
      let list = that.salesData[tn];
      let index = list.findIndex(x => {
        return x.id == row.id;
      })
      let one = list[index];
      if (one) {
        that.$prompt('改多少', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputValue: ''
        }).then(({
          value
        }) => {
          let multi = parseInt(value);
          if (multi) {
            one[col.property] = multi;
          } else {
            that.$message.error('请填写正确的数字');
          }
        }).catch((err) => {
          console.log('取消修改', err);
        })
      }
    },
    cancalReadOnly(onOff) {
      this.$nextTick(() => {
        if (!onOff) {
          const Selects = this.$refs;
          if (Selects.agent1Select) {
            const input = Selects.agent1Select.$el.querySelector(
              ".el-input__inner"
            );
            input.removeAttribute("readonly");
          }
          if (Selects.agent2Select) {
            const appinput = Selects.agent2Select.$el.querySelector(
              ".el-input__inner"
            );
            appinput.removeAttribute("readonly");
          }
        }
      });
    },
    countProperties(obj) {
      let count = 0;
      for (let prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          count++;
        }
      }
      return count;
    },
    setCellClassName(date) {
      return "custom-date";
    },
    recordView() {
      if(this.real_estate_id.length===0){
        this.$message.error('请选择楼盘');
        return;
      }
      for (let index = 0; index < this.real_estate_id.length; index++){
              let parameter = {
        type:'报表下载',
        estate_id:this.real_estate_id[index],
      }
      console.log(parameter);
      this.$axios.post(this.$url_prefix + "business/recordview", parameter).then(res => {
        console.log(res);
      });
      }

    },
    shotPic() {
      this.recordView();
      const node = document.getElementById('my-node')
      domtoimage
        .toPng(node)
        .then((dataUrl) => {
          const a = document.createElement('a')
          const event = new MouseEvent('click')
          a.download = `策划广告数据统计_${new Date().toLocaleDateString().replaceAll("/", "_")}`
          a.href = dataUrl
          a.dispatchEvent(event)
        })
        .catch(function (error) {
          console.error('oops, something went wrong!', error)
        })
    }
  }
}
</script>

<style scoped>
.app-container {
  min-width: 1200px;
  padding: 30px 20px;
  background: url('../../static/images/xjht_sw_bg.png') #ffdd56;
  background-position: top center;
  background-repeat: no-repeat;
  background-size: 100%;
}

.logo {
  margin: 0 0 20px;
  width: 185px;
  height: 45px;
}

.userBar {
  padding: 20px;
  border-radius: 20px;
  background-color: #fff;
}

.row-public {
  margin-bottom: 10px;
  width: 100%;
  display: flex;
  align-items: center;
}

.select-flex1 {
  flex: 1;
}

.right {
  margin-left: 30px;
}

.space {
  margin: 0 20px;
  font-size: 14px;
}

.text {
  margin: 10px 20px 10px 0;
  font-size: 14px;
  color: #000000;
}

.date-item {
  width: 318px;
}

.select-btn,
.download-btn {
  margin: 0 0 0 76px;
  width: 123px;
  height: 42px;
  color: #333;
  font-size: 14px;
  background: #FDE247;
  border-radius: 4px;
  border: 0;
}

.download-btn {
  margin: 10px 0 0 20px;
}

.table-box {
  margin: 10px 0 0;
  padding: 20px;
  border-radius: 20px;
  background-color: #fff;
}

.estate-box {
  overflow-x: auto;
}

.estate-table {
  margin: 0 0 20px 0;
}

.title {
  margin: 0 0 16px 0;
  font-size: 18px;
  font-weight: 700;
  color: #000;
}

/deep/ .el-input--mini .el-input__inner {
  min-height: 42px !important;
  line-height: 42px !important;
  font-size: 14px;
}

/deep/ .el-input--mini .el-input__inner::placeholder {
  color: #DCDFE6;
  font-size: 14px;
}

/deep/ .el-tag.el-tag--info {
  border: 0;
  background-color: #fff;
  color: #333;
  font-size: 14px;
}

/deep/ .el-select .el-tag__close.el-icon-close {
  background-color: #fff;
  color: #333;
  font-size: 20px;
}

/deep/ .el-radio__input.is-checked .el-radio__inner {
  width: 20px;
  height: 20px;
  background: #00000000;
  background-color: #00000000;
  background-image: url('../../static/images/xjht_radio_select.png');
  background-size: 100% 100%;
  border: 0;
}

/deep/ .el-radio__inner {
  width: 20px;
  height: 20px;
}

/deep/ .el-radio__inner::after {
  width: 0;
  height: 0;
  background: #00000000;
}

/deep/ .el-radio__input.is-checked+.el-radio__label {
  color: #333;
}

/deep/ .el-table tr {
  background-color: #FFFEF9;
}

/deep/ .el-table td {
  height: 40px;
  font-size: 14px;
  color: #000000A6;
  text-align: center;
}

/deep/ .el-date-table td span {
  border-radius: 4px !important;
}

/deep/ .el-table th.el-table__cell {
  height: 40px;
  background-color: #FFF7C9;
  text-align: center;
  font-size: 14px;
  color: #000000D9;
  font-weight: 400;
  border-bottom: 1px solid #FFEB79 !important;
  border-top: 1px solid #FFEB79 !important;
}

/deep/ .el-table th.el-table__cell:first-of-type {
  border-left: 1px solid #FFEB79 !important;
}

/deep/ .el-table th.el-table__cell:nth-last-of-type(2) {
  border-right: 1px solid #FFEB79 !important;

}

/deep/ .el-table--border {
  border: 0;
}

/deep/ .el-table tr td:last-of-type {
  border-right: 0 !important;
}

/deep/ .el-table--border::after {
  background-color: #00000000;
}
</style>
<style>
.custom-date.current:not(.disabled) span {
  background-color: #FFEB79 !important;
  color: #31373D !important;
  border-radius: 4px;
}

.realTable-select .el-select-dropdown__item.hover {
  background-color: #FFF7C9 !important;
  color: #FCA130 !important;
}

.realTable-select .el-select-dropdown__item.selected {
  color: #FCA130 !important;
}
</style>



// WEBPACK FOOTER //
// src/page/RealTable.vue